import React, { useState } from 'react';
import { ChevronDown, Send, Mail, Phone, Globe, MessageSquare, Building, Briefcase, Shield, AlertTriangle, CheckCircle, X, HelpCircle, ChevronRight } from 'lucide-react';
interface ContactSinShiftProps {
  onBack: () => void;
}
type QueryType = 'customer' | 'media' | 'law' | 'partnership' | 'other' | null;
export const ContactSinShift: React.FC<ContactSinShiftProps> = ({
  onBack
}) => {
  const [activeQuery, setActiveQuery] = useState<QueryType>(null);
  const [legalInquiryType, setLegalInquiryType] = useState<string>('');
  const [showLegalInquiryDropdown, setShowLegalInquiryDropdown] = useState(false);
  const [isEmergency, setIsEmergency] = useState<boolean | null>(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would send the form data
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setActiveQuery(null);
    }, 3000);
  };
  const renderQuerySelector = () => {
    return <div className="space-y-4" data-id="element-8394">
        <h2 className="text-xl font-bold" data-id="element-8395">Contact SinShift</h2>
        <p className="text-gray-600 dark:text-gray-400" data-id="element-8396">
          Select the type of query you have, and we'll direct you to the right
          team.
        </p>
        <div className="grid gap-3 mt-6" data-id="element-8397">
          <button onClick={() => setActiveQuery('customer')} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-8398">
            <div className="flex items-center gap-3" data-id="element-8399">
              <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-blue-500" data-id="element-8400">
                <MessageSquare size={18} data-id="element-8401" />
              </div>
              <div className="text-left" data-id="element-8402">
                <h3 className="font-medium" data-id="element-8403">Customer Support Queries</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-8404">
                  Account issues, billing, technical support
                </p>
              </div>
            </div>
            <ChevronRight size={18} className="text-gray-400" data-id="element-8405" />
          </button>
          <button onClick={() => setActiveQuery('media')} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-8406">
            <div className="flex items-center gap-3" data-id="element-8407">
              <div className="w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-500" data-id="element-8408">
                <Globe size={18} data-id="element-8409" />
              </div>
              <div className="text-left" data-id="element-8410">
                <h3 className="font-medium" data-id="element-8411">Media/Press Queries</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-8412">
                  Interviews, press releases, media kit
                </p>
              </div>
            </div>
            <ChevronRight size={18} className="text-gray-400" data-id="element-8413" />
          </button>
          <button onClick={() => setActiveQuery('law')} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-8414">
            <div className="flex items-center gap-3" data-id="element-8415">
              <div className="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-500" data-id="element-8416">
                <Shield size={18} data-id="element-8417" />
              </div>
              <div className="text-left" data-id="element-8418">
                <h3 className="font-medium" data-id="element-8419">Law Enforcement Queries</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-8420">
                  Legal requests, subpoenas, court orders
                </p>
              </div>
            </div>
            <ChevronRight size={18} className="text-gray-400" data-id="element-8421" />
          </button>
          <button onClick={() => setActiveQuery('partnership')} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-8422">
            <div className="flex items-center gap-3" data-id="element-8423">
              <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-500" data-id="element-8424">
                <Briefcase size={18} data-id="element-8425" />
              </div>
              <div className="text-left" data-id="element-8426">
                <h3 className="font-medium" data-id="element-8427">Brand or Partnership Queries</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-8428">
                  Collaboration opportunities, business partnerships
                </p>
              </div>
            </div>
            <ChevronRight size={18} className="text-gray-400" data-id="element-8429" />
          </button>
          <button onClick={() => setActiveQuery('other')} className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" data-id="element-8430">
            <div className="flex items-center gap-3" data-id="element-8431">
              <div className="w-10 h-10 rounded-full bg-pink-100 dark:bg-pink-900/30 flex items-center justify-center text-pink-500" data-id="element-8432">
                <HelpCircle size={18} data-id="element-8433" />
              </div>
              <div className="text-left" data-id="element-8434">
                <h3 className="font-medium" data-id="element-8435">Any Other Queries</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-8436">
                  Other inquiries not covered above
                </p>
              </div>
            </div>
            <ChevronRight size={18} className="text-gray-400" data-id="element-8437" />
          </button>
        </div>
      </div>;
  };
  const renderLawEnforcementForm = () => {
    return <div className="space-y-4" data-id="element-8438">
        <div className="flex items-center justify-between" data-id="element-8439">
          <h2 className="text-xl font-bold" data-id="element-8440">Law Enforcement Request Form</h2>
          <button onClick={() => setActiveQuery(null)} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-8441">
            <X size={18} data-id="element-8442" />
          </button>
        </div>
        <div className="bg-pink-50 dark:bg-pink-900/20 p-4 rounded-lg border border-pink-200 dark:border-pink-800/30" data-id="element-8443">
          <p className="text-sm" data-id="element-8444">
            <strong data-id="element-8445">Note:</strong> Use of this contact form is limited
            exclusively to law enforcement agencies. If you are not a law
            enforcement representative, please contact us at{' '}
            <a href="mailto:support@sinshift.com" className="text-pink-600 dark:text-pink-400 hover:underline" data-id="element-8446">
              support@sinshift.com
            </a>
          </p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4" data-id="element-8447">
          {/* Legal Inquiry Type Dropdown */}
          <div className="relative" data-id="element-8448">
            <label className="block text-sm font-medium mb-1" data-id="element-8449">
              Matter type of legal inquiry
            </label>
            <button type="button" className="w-full flex items-center justify-between p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg text-left" onClick={() => setShowLegalInquiryDropdown(!showLegalInquiryDropdown)} data-id="element-8450">
              <span className={legalInquiryType ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-400'} data-id="element-8451">
                {legalInquiryType || 'Select inquiry type'}
              </span>
              <ChevronDown size={18} className="text-gray-500" data-id="element-8452" />
            </button>
            {showLegalInquiryDropdown && <div className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg overflow-hidden" data-id="element-8453">
                <div className="max-h-60 overflow-y-auto" data-id="element-8454">
                  {['Civil Subpoena', 'Civil Court Order', 'Criminal Search Warrant / Court Order', 'Criminal Subpoena / Judicial Authorization / Production Order', 'Other'].map(type => <button key={type} type="button" className="w-full px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" onClick={() => {
                setLegalInquiryType(type);
                setShowLegalInquiryDropdown(false);
              }} data-id="element-8455">
                      {type}
                    </button>)}
                </div>
              </div>}
          </div>
          {/* Agency Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8456">
            <div data-id="element-8457">
              <label className="block text-sm font-medium mb-1" data-id="element-8458">
                Law enforcement agency country
              </label>
              <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Country" required data-id="element-8459" />
            </div>
            <div data-id="element-8460">
              <label className="block text-sm font-medium mb-1" data-id="element-8461">City</label>
              <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="City" required data-id="element-8462" />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8463">
            <div data-id="element-8464">
              <label className="block text-sm font-medium mb-1" data-id="element-8465">
                State / Province (optional)
              </label>
              <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="State or Province" data-id="element-8466" />
            </div>
            <div data-id="element-8467">
              <label className="block text-sm font-medium mb-1" data-id="element-8468">
                ZIP / Postal Code
              </label>
              <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="ZIP or Postal Code" required data-id="element-8469" />
            </div>
          </div>
          <div data-id="element-8470">
            <label className="block text-sm font-medium mb-1" data-id="element-8471">
              Law enforcement address
            </label>
            <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Full address" required data-id="element-8472" />
          </div>
          <div data-id="element-8473">
            <label className="block text-sm font-medium mb-1" data-id="element-8474">
              Name of Court / Police department / Authority
            </label>
            <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Authority name" required data-id="element-8475" />
          </div>
          {/* Contact Person Information */}
          <div data-id="element-8476">
            <label className="block text-sm font-medium mb-1" data-id="element-8477">
              Name of Contact Person handling this matter (Detective,
              investigator, etc.)
            </label>
            <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Full name" required data-id="element-8478" />
          </div>
          <div data-id="element-8479">
            <label className="block text-sm font-medium mb-1" data-id="element-8480">
              Official law enforcement agency email address
            </label>
            <input type="email" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Official email" required data-id="element-8481" />
          </div>
          <div data-id="element-8482">
            <label className="block text-sm font-medium mb-1" data-id="element-8483">
              Contact Person's Phone Number
            </label>
            <input type="tel" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Phone number" required data-id="element-8484" />
          </div>
          {/* Case Details */}
          <div data-id="element-8485">
            <label className="block text-sm font-medium mb-1" data-id="element-8486">
              Description of legal inquiry
            </label>
            <textarea className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg h-32" placeholder="Provide details about your inquiry" required data-id="element-8487"></textarea>
          </div>
          <div data-id="element-8488">
            <label className="block text-sm font-medium mb-1" data-id="element-8489">
              Content Link or URL (optional)
            </label>
            <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="https://" data-id="element-8490" />
          </div>
          {/* Emergency Question */}
          <div data-id="element-8491">
            <p className="block text-sm font-medium mb-2" data-id="element-8492">
              Does this inquiry involve a risk of imminent harm to an
              individual?
            </p>
            <div className="flex items-center gap-4" data-id="element-8493">
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-8494">
                <div className={`w-5 h-5 rounded-full border flex items-center justify-center ${isEmergency === true ? 'border-pink-500 bg-pink-500' : 'border-gray-300 dark:border-gray-700'}`} data-id="element-8495">
                  {isEmergency === true && <div className="w-2 h-2 bg-white rounded-full" data-id="element-8496"></div>}
                </div>
                <span data-id="element-8497">Yes</span>
                <input type="radio" name="emergency" className="sr-only" checked={isEmergency === true} onChange={() => setIsEmergency(true)} data-id="element-8498" />
              </label>
              <label className="flex items-center gap-2 cursor-pointer" data-id="element-8499">
                <div className={`w-5 h-5 rounded-full border flex items-center justify-center ${isEmergency === false ? 'border-pink-500 bg-pink-500' : 'border-gray-300 dark:border-gray-700'}`} data-id="element-8500">
                  {isEmergency === false && <div className="w-2 h-2 bg-white rounded-full" data-id="element-8501"></div>}
                </div>
                <span data-id="element-8502">No</span>
                <input type="radio" name="emergency" className="sr-only" checked={isEmergency === false} onChange={() => setIsEmergency(false)} data-id="element-8503" />
              </label>
            </div>
          </div>
          <div className="pt-4" data-id="element-8504">
            <button type="submit" className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-lg font-medium hover:from-pink-700 hover:to-purple-700 transition-colors" data-id="element-8505">
              Submit Request
            </button>
          </div>
        </form>
      </div>;
  };
  const renderGenericContactForm = (title: string, icon: React.ReactNode) => {
    return <div className="space-y-4" data-id="element-8506">
        <div className="flex items-center justify-between" data-id="element-8507">
          <h2 className="text-xl font-bold flex items-center gap-2" data-id="element-8508">
            {icon}
            <span data-id="element-8509">{title}</span>
          </h2>
          <button onClick={() => setActiveQuery(null)} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-8510">
            <X size={18} data-id="element-8511" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4" data-id="element-8512">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-8513">
            <div data-id="element-8514">
              <label className="block text-sm font-medium mb-1" data-id="element-8515">
                First Name
              </label>
              <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Your first name" required data-id="element-8516" />
            </div>
            <div data-id="element-8517">
              <label className="block text-sm font-medium mb-1" data-id="element-8518">
                Last Name
              </label>
              <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Your last name" required data-id="element-8519" />
            </div>
          </div>
          <div data-id="element-8520">
            <label className="block text-sm font-medium mb-1" data-id="element-8521">
              Email Address
            </label>
            <input type="email" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Your email address" required data-id="element-8522" />
          </div>
          <div data-id="element-8523">
            <label className="block text-sm font-medium mb-1" data-id="element-8524">Subject</label>
            <input type="text" className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg" placeholder="Subject of your inquiry" required data-id="element-8525" />
          </div>
          <div data-id="element-8526">
            <label className="block text-sm font-medium mb-1" data-id="element-8527">Message</label>
            <textarea className="w-full p-3 bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg h-32" placeholder="Please provide details about your inquiry" required data-id="element-8528"></textarea>
          </div>
          <div className="pt-4" data-id="element-8529">
            <button type="submit" className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-lg font-medium hover:from-pink-700 hover:to-purple-700 transition-colors" data-id="element-8530">
              Submit Inquiry
            </button>
          </div>
        </form>
      </div>;
  };
  const renderActiveQuery = () => {
    switch (activeQuery) {
      case 'customer':
        return renderGenericContactForm('Customer Support', <MessageSquare size={20} className="text-blue-500" data-id="element-8531" />);
      case 'media':
        return renderGenericContactForm('Media & Press Inquiries', <Globe size={20} className="text-purple-500" data-id="element-8532" />);
      case 'law':
        return renderLawEnforcementForm();
      case 'partnership':
        return renderGenericContactForm('Partnership Opportunities', <Briefcase size={20} className="text-green-500" data-id="element-8533" />);
      case 'other':
        return renderGenericContactForm('General Inquiry', <HelpCircle size={20} className="text-pink-500" data-id="element-8534" />);
      default:
        return renderQuerySelector();
    }
  };
  return <div className="max-w-3xl mx-auto" data-id="element-8535">
      {formSubmitted && <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm" data-id="element-8536">
          <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-lg max-w-md w-full animate-in zoom-in-95 duration-300" data-id="element-8537">
            <div className="flex flex-col items-center text-center" data-id="element-8538">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-4" data-id="element-8539">
                <CheckCircle size={32} className="text-green-500" data-id="element-8540" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-8541">Submission Received</h3>
              <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-8542">
                Thank you for contacting SinShift. We'll get back to you as soon
                as possible.
              </p>
              <button className="px-6 py-2 bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-lg font-medium" onClick={() => {
            setFormSubmitted(false);
            setActiveQuery(null);
          }} data-id="element-8543">
                Close
              </button>
            </div>
          </div>
        </div>}
      <button onClick={onBack} className="flex items-center gap-2 px-3 py-2 bg-gray-50 dark:bg-gray-900 backdrop-filter backdrop-blur-md border border-gray-100 dark:border-gray-700 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all mb-6" data-id="element-8544">
        <ChevronLeft size={16} data-id="element-8545" />
        <span data-id="element-8546">Back to Help Center</span>
      </button>
      {renderActiveQuery()}
    </div>;
};
// Additional icon component
const ChevronLeft = ({
  size,
  className
}: {
  size: number;
  className?: string;
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-8547">
    <polyline points="15 18 9 12 15 6" data-id="element-8548"></polyline>
  </svg>;